import React from 'react';
import MessageConst from '../../../const/RTCC/messageConst';
import "../../../resources/RTCC/css/common/radio_box_style.css";
import { Label } from '../../atoms/RTCC/label';
import './../../../resources/RTCC/css/userInput/userInput.css';

export const HumanInputForm = (props) => {
    // 人数入力欄作成
    const rooms = () => {
        const roomList = [];
        for (let i = 0; i < props.roomNum; i++) {
            roomList.push(
                <div key={"room" + i} className="userRoomIndex">
                    {props.roomList[i] ? <>
                        <div style={styles.human}>
                            <Label label={(i + 1) + "部屋目"} className="inputTitleLabel2" />
                            <div style={styles.human}>
                                <Label label={"大人"} className="humanLabel" />
                                <Label label={props.roomList[i] ? props.roomList[i].adultSum + "人" : "0人"} className="humanLabel" />
                            </div>
                        </div>
                        <div style={styles.human}>
                            {/* <PullDownOptionForm
                            wrapClassName="inputPullDownWrap"
                            labelClassName="userTypeChildLabel"
                            title={"こども"}
                            className="inputPullDownButton"
                            data={props.human}
                            id={"child" + i}
                            state={props.roomList[i] ? props.roomList[i].childSum : 0}
                            onChange={() => props.onChange("child" + i, i)}
                        /> */}
                            {props.roomList[i].childSum > 0 ? <>
                                <div></div>
                                <div style={styles.human}>
                                    <Label label={"こども"} className="humanLabel" />
                                    <Label label={props.roomList[i] ? props.roomList[i].childSum + "人" : "0人"} className="humanLabel" />
                                </div>
                            </>
                                : null}
                        </div>
                    </>
                        : null}
                    {/* <div style={styles.human}>
                        <PullDownOptionForm
                            wrapClassName="inputPullDownWrap"
                            labelClassName="userTypeShareLabel"
                            title={"こども（添寝）"}
                            className="inputPullDownButton"
                            data={props.human}
                            id={"share" + i}
                            state={props.roomList[i] ? props.roomList[i].childSleepingSum : 0}
                            onChange={() => props.onChange("share" + i, i)}
                        />
                        <Label label={"人"} className="humanLabel" />
                    </div> */}
                </div>
            );
        }
        return <>{roomList}</>;
    }

    return (
        <>
            {rooms()}
        </>
    );
}

const styles = {
    luxuryCollection: {
        display: "block",
        marginBottom: "16px",
        color: "white",
        backgroundColor: "#c1ab05",
        height: "20px",
        width: "180px",
        textAlign: "center",
        alignItems: "center",
        fontSize: "small"
    },
    feeLabel: {
        whiteSpace: "nowrap",
        color: "gray",
        fontSize: "small",
    },
    fee: {
        fontWeight: "bold",
        padding: "0px 16px",
        fontSize: "large",
        whiteSpace: "nowrap",
    },
    human: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
    },
}